export const IconExclamation = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={70} height={70} viewBox="0 0 70 70" fill="#1890FF" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M35 0C15.6719 0 0 15.6719 0 35C0 54.3281 15.6719 70 35 70C54.3281 70 70 54.3281 70 35C70 15.6719 54.3281 0 35 0ZM32.5 18.125C32.5 17.7812 32.7812 17.5 33.125 17.5H36.875C37.2188 17.5 37.5 17.7812 37.5 18.125V39.375C37.5 39.7188 37.2188 40 36.875 40H33.125C32.7812 40 32.5 39.7188 32.5 39.375V18.125ZM35 52.5C34.0187 52.48 33.0843 52.0761 32.3974 51.375C31.7105 50.6739 31.3258 49.7315 31.3258 48.75C31.3258 47.7685 31.7105 46.8261 32.3974 46.125C33.0843 45.4239 34.0187 45.02 35 45C35.9813 45.02 36.9157 45.4239 37.6026 46.125C38.2895 46.8261 38.6742 47.7685 38.6742 48.75C38.6742 49.7315 38.2895 50.6739 37.6026 51.375C36.9157 52.0761 35.9813 52.48 35 52.5Z"
        fill="#1890FF"
      />
    </svg>
  );
};
